export const PROPERTY_INFO_KEY = "propertyInfo";
export const PROPERTY_INFO_CHANGED_EVENT = "adukkumadi:propertyInfoChanged";

export function normalizePropertyInfo(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[\s_-]/g, "");
}

function isOwner(role) {
  return String(role || "").toUpperCase() === "OWNER";
}

/** Owner can use the rest of the app only after propertyInfo is Approved. */
export function isOwnerAwaitingPropertyApproval(role, propertyInfo) {
  if (!isOwner(role)) return false;
  const status = normalizePropertyInfo(propertyInfo);
  return status === "waitingforapproval" || status === "pending";
}

/** pending owners fill the property form; waitingforApproval owners see the view. */
export function isOwnerPropertyPending(role, propertyInfo) {
  return isOwner(role) && normalizePropertyInfo(propertyInfo) === "pending";
}

export function ownerRestrictedHomePath(role, propertyInfo) {
  if (isOwnerPropertyPending(role, propertyInfo)) return "/property-details-add";
  if (isOwnerAwaitingPropertyApproval(role, propertyInfo)) return "/property-details";
  return "/dashboard";
}

export function readPropertyInfo() {
  try {
    return localStorage.getItem(PROPERTY_INFO_KEY) || "";
  } catch {
    return "";
  }
}

export function writePropertyInfo(value) {
  const next = value == null ? "" : String(value).trim();
  try {
    if (next) localStorage.setItem(PROPERTY_INFO_KEY, next);
    else localStorage.removeItem(PROPERTY_INFO_KEY);
  } catch {
    return;
  }
  window.dispatchEvent(new Event(PROPERTY_INFO_CHANGED_EVENT));
}

function payloadText(value) {
  return String(value || "").trim();
}

/** Owner session: socket says this user's property was approved. */
export function applyOwnerPropertyApprovalFromSocket(data) {
  console.log("[property-approval] listener input", data);
  let role = "";
  let me = "";
  try {
    role = localStorage.getItem("role") || "";
    me = payloadText(localStorage.getItem("userid"));
  } catch (error) {
    console.log("[property-approval] listener storage read failed", error?.message || error);
    return false;
  }

  const action = payloadText(data?.action || data?.type || data?.event).toLowerCase();
  const info = data?.propertyInfo ?? data?.data?.propertyInfo ?? data?.payload?.propertyInfo ?? null;
  const looksLikeApproval =
    action.includes("property") || action.includes("approv") || normalizePropertyInfo(info) === "approved";
  if (!looksLikeApproval) {
    console.log("[property-approval] ignored, not an approval payload", {
      role,
      myUserId: me,
      action,
      propertyInfo: info,
      payload: data
    });
    return false;
  }

  const targets = [
    data?.ownerId,
    data?.targetUserId,
    data?.targetUserid,
    data?.userid,
    data?.userId,
    data?.data?.id,
    data?.data?.userid,
    data?.data?.ownerId,
    data?.id
  ]
    .map(payloadText)
    .filter(Boolean);
  const normalized = normalizePropertyInfo(info);
  const isOwnerSession = isOwner(role);
  const isApprovalEvent =
    action === "propertyinfo.updated" ||
    action === "property.approved" ||
    action === "admin.approveproperty" ||
    normalized === "approved";
  const matched = isOwnerSession && !!me && isApprovalEvent && (info == null || normalized === "approved") && targets.includes(me);

  console.log("[property-approval] owner socket received", {
    role,
    myUserId: me,
    action,
    propertyInfo: info,
    targets,
    matched,
    localPropertyInfo: readPropertyInfo(),
    payload: data
  });

  if (!matched) return false;

  writePropertyInfo("Approved");
  console.log("[property-approval] owner localStorage updated", {
    propertyInfo: readPropertyInfo()
  });
  return true;
}
